import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import { ctaSectionData } from '../mock/data';

const CTASection = () => {
  const scrollToPricing = () => {
    const element = document.querySelector('#pricing');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-[#52a675] to-[#3d8a5c] rounded-3xl p-12 lg:p-16 text-center text-white shadow-2xl animate-in fade-in slide-in-from-bottom duration-700">
            <h2 className="text-3xl lg:text-5xl font-bold mb-4">
              {ctaSectionData.title}
            </h2>
            <p className="text-xl mb-8 opacity-95">
              {ctaSectionData.subtitle}
            </p>
            <Button
              size="lg"
              onClick={scrollToPricing}
              className="bg-white text-[#52a675] hover:bg-gray-100 px-8 py-6 text-lg shadow-lg hover:shadow-xl transition-all duration-300 group"
            >
              {ctaSectionData.ctaText}
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
